<template>
    <div class="statement-block">
        <div :class="{'statement-block-header': true, 'left-alignment': all === true}">
            <span v-text="group.date"></span>

            <button class="btn statement-btn-add" @click="newTransaction" v-if="all & showBtn">
                <i class="icon icon-plus"></i>
                <span>{{ $t('Добавить операцию') }}</span>
            </button>
        </div>
        <div class="statement-block-container">
            <StatementItem :item="transaction" v-for="transaction in group.transactions" :key="transaction.id" />
        </div>
    </div>
</template>

<script>
import StatementItem from './StatementItem.vue';
import { EventBus } from '../../../event-bus';

export default {
    name: "StatementBlock",

    components: {
        StatementItem,
    },

    props: ['group', 'all', 'showBtn'],

    methods: {
        newTransaction() {
            EventBus.$emit('open-side-form', 'new-transaction');
        }
    }
}
</script>

<style scoped lang="scss">
.statement-block {
    .statement-block-header {
        text-align: center;
        color: rgba(#152640, .5);
        font-size: 12px;
        font-family: 'Proxima Nova Rg';
        padding: 4px 0;

        display: flex;
        align-items: center;
        justify-content: center;

        &.left-alignment {
            span {
                @media (min-width: 768px) {
                    margin-right: auto;
                }
            }
        }

        .statement-btn-add {
            padding: 8px;
            background: #152640;
            border: none;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            display: flex;
            align-items: center;
            min-width: 140px;
            margin-left: 8px;

            @media (max-width: 768px) {
                display: none;
            }

            .icon {
                background-color: #fff;
                width: 16px;
                height: 16px;
            }

            span {
                margin-left: 6px;
                font-family: 'Proxima Nova Lt';
                font-weight: 600;
                font-size: 12px;
            }
        }
    }

    .statement-block-container {
        //
    }
}
</style>